module.exports = __webpack_public_path__ + "media/images/new/icons/facebook@2x-84f453b372721082c89dd6e78af2aa62.png";